export default {
  'zh-CN': {
    importErrTip: '提示：共{allNum}条数据，问题数据{errNum}条，你可以返回修改后重新上传，或者先导入正确数据。',
    downFileBtn: '下载数据文件',
    clickLoadMore: '点击加载更多数据',
    importLaterTip: '导入成功，{sec}秒后自动为您关闭!',
    operationSuccess: '操作成功！',
    importNumTip: '导入成功{successCount}条，失败{failCount}条。',
    backList: '返回列表',
    importData: '上传数据',
    checkImport: '检验并导入数据',
    finish: '完成',
    nextStep: '下一步',
    upSuccessData: '导入正确数据',
    downErrData: '下载问题数据',
    close: '关闭',
    beforeStep: '上一步',
    importTips: '请导入表格文件',
    upSuccess: '上传成功'
  },
  'en': {
    importErrTip: 'Prompt: {allNum}pieces of data in total. {errNum}problem pieces of data. You can go back and reupload, or import the correct data first.',
    downFileBtn: 'Download data files',
    clickLoadMore: 'Click to load more data',
    importLaterTip: 'Import succeeded! Auto-close in {sec}seconds!',
    operationSuccess: 'Operation succeeded!',
    importNumTip: '{successCount}pieces import succeeded. {failCount}pieces import failed.',
    backList: 'Back to list',
    importData: 'Upload data',
    checkImport: 'Verify and import data',
    finish: 'Finished',
    nextStep: 'Next',
    upSuccessData: 'Import Correct Data',
    downErrData: 'Download problem data',
    close: 'Close',
    beforeStep: 'Previous step',
    importTips: 'Please import the form file',
    upSuccess: 'Upload succeeded'
  },
  'ja': {
    importErrTip: '提示：共{allNum}条数据，问题数据{errNum}条，你可以返回修改后重新上传，或者先导入正确数据。_ja',
    downFileBtn: '下载数据文件_ja',
    clickLoadMore: '点击加载更多数据_ja',
    importLaterTip: '导入成功，{sec}秒后自动为您关闭!_ja',
    operationSuccess: '操作成功！_ja',
    importNumTip: '导入成功{successCount}条，失败failCount}条。_ja',
    backList: '返回列表_ja',
    importData: '上传数据_ja',
    checkImport: '检验并导入数据_ja',
    finish: '完成_ja',
    nextStep: '下一步_ja',
    upSuccessData: '导入正确数据_ja',
    downErrData: '下载问题数据_ja',
    close: '关闭_ja',
    beforeStep: '上一步_ja',
    importTips: '请导入表格文件_ja',
    upSuccess: '上传成功_ja'
  }
}
